<template lang="pug">
Auth(@loggedIn="onLoggedIn", @loginFailed="onFailedAuthentication")
  Header(:content="headerContent")
  ModalPage(
    v-if="uid",
    @closeModalPage="closeModalPage",
    modalPageContentId="lecture",
    :modalHeaderContent="modalHeaderContent",
    :showModal="showModalPage"
  )
  ModalWindow(
    @closeModalWindow="closeModalWindow",
    modalContentId="subscription",
    :showModal="showModalWindow"
  )
  .wrap-home.f.fh
    ModuleLectureList(
      v-if="user && course",
      :course="course",
      :user="user",
      @showModalWindow="() => { showModalWindow = true; }"
    )
</template>

<style lang="scss" scoped>
.wrap-home {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

import Auth from '@/components/auth'
import Header from '@/components/shared/Header.vue'
import ModalWindow from '@/components/shared/ModalWindow.vue'
import ModalPage from '@/components/shared/ModalPage.vue'

import ModuleLectureList from '@/components/module/ModuleLectureList'
import { database } from '@shared/database'

export default {
  components: {
    Auth,
    Header,
    ModalWindow,
    ModalPage,
    ModuleLectureList
  },
  data () {
    return {
      // headerContent: {
      //   label: '',
      //   leftAction: {
      //     icon: 'playlist_add_check',
      //     color: '#fff',
      //     method: this.toCourseList
      //   },
      //   rightActions: [
      //     {
      //       icon: 'person',
      //       color: '#fff',
      //       method: this.toMyPage
      //     },
      //     {
      //       icon: 'settings',
      //       color: '#fff',
      //       method: this.toSettings
      //     }
      //   ]
      // },
      headerContent: {
        label: '',
        leftAction: {
          icon: 'person',
          color: '#fff',
          method: this.toMyPage
        },
        rightActions: [
          {
            icon: 'settings',
            color: '#fff',
            method: this.toSettings
          }
        ]
      },
      modalHeaderContent: {
        label: '',
        leftAction: {
          icon: 'navigate_before',
          color: '#fff',
          method: this.onModalHeaderLeft
        }
      },
      showModalPage: false,
      showModalWindow: false,
      user: null,
      course: null,
      subscribedCourse: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
        if (this.$route.params.lectureIndex) {
          this.showModalPage = true

          this.modalHeaderContent.label = this.course.lectures[this.$route.params.lectureIndex].title
        } else {
          this.showModalPage = false
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.course = null
      // this.subscribedCourse = null

      if (this.$route.params.lectureIndex) this.showModalPage = true

      // this.course = await db.collection('COURSES')
      //   .doc(this.$route.params.id)
      //   .get()
      //   .then(d => {
      //     var data = d.data()
      //     data.id = d.id
      //     return data
      //   })
      this.course = await database.getCourse(this.$route.params.id)
      this.headerContent.label = this.course.title

      // db.collection('USERS')
      //   .doc(this.uid)
      //   .onSnapshot(this.handleUser)  
      database.onTraineeUpdated(this.uid, this.handleUser)

      // this.subscribedCourse = await db.collection('USERS')
      //   .doc(this.uid)
      //   .collection('SUBSCRIBED_COURSES')
      //   .doc(this.$route.params.id)
      //   .get()
      //   .then((d) => {
      //     return d.data()
      //   })
      
      // if (!this.subscribedCourse) this.showModalWindow = true

      // this.subscribedCourse = await db.collection('USERS')
      //   .doc(this.uid)
      //   .collection('SUBSCRIBED_COURSES')
      //   .doc(this.$route.params.id)
      //   .onSnapshot(this.handleList)
    },
    handleUser (trainee) {
      this.user = trainee
      // TODO LamDV
      // if (!this.user.plans.includes(this.$route.params.id)) this.showModalWindow = true
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async onLoggedIn () {
      // this.user = await db.collection('USERS')
      //   .doc(this.uid)
      //   .get()
      //   .then(d => {
      //     var data = d.data()
      //     data.uid = d.id
      //     return data
      //   })
      this.user = await database.getTrainee(this.uid)
      
      // TODO LamDV
      // if (!this.user.plans.includes('digital_learning')) this.showModalWindow = true
    },
    onHeaderRight () {

    },
    onModalHeaderLeft () {
      this.$router.push(`/course/${this.course.id}`)
    },
    closeModalPage () {
      this.showModalPage = false
    },
    closeModalWindow () {
      this.showModalWindow = false
    },
    toCourseList () {
      this.$router.push('/course/digital_learning')
    },
    toMyPage () {
      this.$router.push(`/users/${this.uid}`)
    },
    toSettings () {
      this.$router.push('/settings')
    }
  }
}
</script>
